import { getYoutubeVideoId } from 'components/shared/linkPreviewUrls'

export function getLastUrlPathSegment(url) {
    if (!url || typeof url !== 'string') return null

    try {
        return new URL(url).pathname.replace(/\/+$/, '').split('/').pop() || null
    } catch (e) {
        return url.split('?')[0].split('#')[0].replace(/\/+$/, '').split('/').pop() || null
    }
}

export function normalizePreviewUrl(url) {
    if (url && typeof url === 'object' && typeof url.previewUrl === 'string') {
        url = url.previewUrl
    }
    if (!url || typeof url !== 'string') return null

    try {
        const parsedUrl = new URL(url, window.location.href)
        const normalizedProtocol = parsedUrl.protocol.toLowerCase()
        const normalizedHostname = parsedUrl.hostname.toLowerCase().replace(/^(www\.|m\.)/, '')
        const youtubeVideoId = getYoutubeVideoId(parsedUrl.href)
        if (youtubeVideoId) {
            return `youtube://${youtubeVideoId}`
        }
        const twitterStatusId = extractTwitterStatusId(parsedUrl, normalizedHostname)
        if (twitterStatusId) {
            return `twitter://${twitterStatusId}`
        }
        const isDefaultPort =
            !parsedUrl.port ||
            (normalizedProtocol === 'http:' && parsedUrl.port === '80') ||
            (normalizedProtocol === 'https:' && parsedUrl.port === '443')
        const normalizedPort = isDefaultPort ? '' : `:${parsedUrl.port}`
        const normalizedPathname = parsedUrl.pathname.replace(/\/+$/, '') || '/'
        return `${normalizedProtocol}//${normalizedHostname}${normalizedPort}${normalizedPathname}${parsedUrl.search}`
    } catch (e) {
        const [withoutHash] = url.split('#')
        const [base, search = ''] = withoutHash.split('?')
        const normalizedBase = (base || '').replace(/\/+$/, '')
        return normalizedBase ? `${normalizedBase}${search ? `?${search}` : ''}` : null
    }
}

export function areSamePreviewUrl(leftUrl, rightUrl) {
    const normalizedLeftUrl = normalizePreviewUrl(leftUrl)
    const normalizedRightUrl = normalizePreviewUrl(rightUrl)
    return !!normalizedLeftUrl && normalizedLeftUrl === normalizedRightUrl
}

export function addSuppressedPreviewUrl(existingUrls, targetUrl) {
    if (!targetUrl) return existingUrls || []
    const nextUrls = [...(existingUrls || [])]
    if (nextUrls.some(url => areSamePreviewUrl(url, targetUrl))) {
        return nextUrls
    }
    return [...nextUrls, targetUrl]
}

export function pruneSuppressedPreviewUrls(existingUrls, allowedUrls) {
    return (existingUrls || []).filter(url =>
        (allowedUrls || []).some(allowedUrl => areSamePreviewUrl(url, allowedUrl)),
    )
}

export function filterSuppressedPreviewUrls(urls, suppressedUrls) {
    return (urls || []).filter(
        url => !(suppressedUrls || []).some(suppressedUrl => areSamePreviewUrl(url, suppressedUrl)),
    )
}

function extractTwitterStatusId(parsedUrl, normalizedHostname) {
    if (normalizedHostname !== 'twitter.com' && normalizedHostname !== 'x.com') {
        return null
    }

    const pathSegments = parsedUrl.pathname.replace(/\/+$/, '').split('/').filter(Boolean)
    const statusIndex = pathSegments.findIndex(segment => segment === 'status')
    if (statusIndex === -1) return null

    return pathSegments[statusIndex + 1] || null
}
